import Vue from 'vue'

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/app';
import 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyC5SFTchlS-Oe2Bq2M6So_7EodRo34nFhU",
    authDomain: "limemotion-video-tool.firebaseapp.com",
    databaseURL: "https://limemotion-video-tool.firebaseio.com",
    projectId: "limemotion-video-tool",
    storageBucket: "limemotion-video-tool.appspot.com",
    messagingSenderId: "275257032317",
    appId: "1:275257032317:web:dbe8eec3813bbf6e35bb14",
    measurementId: "G-E5GY47JKCN"
};
firebase.initializeApp(firebaseConfig);

try
{
//    firebase.analytics();       //https://razbakov.com/vue-google-firebase-analytics/
    // alias
    Vue.prototype.$analytics = firebase.analytics();
}
catch (e)
{
    alert('Cookies müssen eingeschalten sein, damit diese Seite ordnungsgemäß funktioniert');
    //alert(e.message);
}



// firebase utils
const fire = firebase;
const db = firebase.firestore()
const auth = firebase.auth()
let currentUser = auth.currentUser
const storage = firebase.storage()
let app = firebase.app()

// firebase collections
const ordersCollection = db.collection('orders')
const usersCollection = db.collection('customers')


export {
    fire,
    app,
    db,
    auth,
    storage,
    currentUser,
    ordersCollection,
    usersCollection,
}
